"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProfileDto = instanceOfProfileDto;
exports.ProfileDtoFromJSON = ProfileDtoFromJSON;
exports.ProfileDtoFromJSONTyped = ProfileDtoFromJSONTyped;
exports.ProfileDtoToJSON = ProfileDtoToJSON;
exports.ProfileDtoToJSONTyped = ProfileDtoToJSONTyped;
const PhoneNumberDto_1 = require("./PhoneNumberDto");
const AlertType_1 = require("./AlertType");
const State_1 = require("./State");
const ProfilePayrollDto_1 = require("./ProfilePayrollDto");
const Roles_1 = require("./Roles");
const AddressDto_1 = require("./AddressDto");
/**
 * Check if a given object implements the ProfileDto interface.
 */
function instanceOfProfileDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('homeState' in value) || value['homeState'] === undefined)
        return false;
    if (!('howDidYouHearAboutUs' in value) || value['howDidYouHearAboutUs'] === undefined)
        return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('ncsbnId' in value) || value['ncsbnId'] === undefined)
        return false;
    if (!('addresses' in value) || value['addresses'] === undefined)
        return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined)
        return false;
    if (!('dismissedAlerts' in value) || value['dismissedAlerts'] === undefined)
        return false;
    if (!('verifiedFacilities' in value) || value['verifiedFacilities'] === undefined)
        return false;
    if (!('specialties' in value) || value['specialties'] === undefined)
        return false;
    if (!('payroll' in value) || value['payroll'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('professionalSummary' in value) || value['professionalSummary'] === undefined)
        return false;
    if (!('isBlocked' in value) || value['isBlocked'] === undefined)
        return false;
    if (!('roles' in value) || value['roles'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('hireDate' in value) || value['hireDate'] === undefined)
        return false;
    return true;
}
function ProfileDtoFromJSON(json) {
    return ProfileDtoFromJSONTyped(json, false);
}
function ProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'homeState': (0, State_1.StateFromJSON)(json['homeState']),
        'howDidYouHearAboutUs': json['howDidYouHearAboutUs'],
        'dateOfBirth': (json['dateOfBirth'] == null ? null : new Date(json['dateOfBirth'])),
        'email': json['email'],
        'ncsbnId': json['ncsbnId'],
        'addresses': (json['addresses'].map(AddressDto_1.AddressDtoFromJSON)),
        'phoneNumber': (0, PhoneNumberDto_1.PhoneNumberDtoFromJSON)(json['phoneNumber']),
        'dismissedAlerts': (json['dismissedAlerts'].map(AlertType_1.AlertTypeFromJSON)),
        'verifiedFacilities': json['verifiedFacilities'],
        'specialties': json['specialties'],
        'payroll': (0, ProfilePayrollDto_1.ProfilePayrollDtoFromJSON)(json['payroll']),
        'createdAt': (new Date(json['createdAt'])),
        'professionalSummary': json['professionalSummary'],
        'isBlocked': json['isBlocked'],
        'roles': (json['roles'].map(Roles_1.RolesFromJSON)),
        'updatedAt': (new Date(json['updatedAt'])),
        'hireDate': (json['hireDate'] == null ? null : new Date(json['hireDate'])),
    };
}
function ProfileDtoToJSON(json) {
    return ProfileDtoToJSONTyped(json, false);
}
function ProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'homeState': (0, State_1.StateToJSON)(value['homeState']),
        'howDidYouHearAboutUs': value['howDidYouHearAboutUs'],
        'dateOfBirth': (value['dateOfBirth'] == null ? null : value['dateOfBirth'].toISOString().substring(0, 10)),
        'email': value['email'],
        'ncsbnId': value['ncsbnId'],
        'addresses': (value['addresses'].map(AddressDto_1.AddressDtoToJSON)),
        'phoneNumber': (0, PhoneNumberDto_1.PhoneNumberDtoToJSON)(value['phoneNumber']),
        'dismissedAlerts': (value['dismissedAlerts'].map(AlertType_1.AlertTypeToJSON)),
        'verifiedFacilities': value['verifiedFacilities'],
        'specialties': value['specialties'],
        'payroll': (0, ProfilePayrollDto_1.ProfilePayrollDtoToJSON)(value['payroll']),
        'createdAt': ((value['createdAt']).toISOString().substring(0, 10)),
        'professionalSummary': value['professionalSummary'],
        'isBlocked': value['isBlocked'],
        'roles': (value['roles'].map(Roles_1.RolesToJSON)),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'hireDate': (value['hireDate'] == null ? null : value['hireDate'].toISOString()),
    };
}
//# sourceMappingURL=ProfileDto.js.map